// 3D Model constants for Chip (passive component) packages
export const chipPinMarkerSize = 0.0002; // Smaller marker for passive components
export const chipPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 600;
export const chipPinMarkerOffsetZ = 0.000001;
export const chipPinMarkerSegments = 16; // Fewer segments for smaller marker
//# sourceMappingURL=chipConstants.js.map